import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Button, Modal, TextArea } from "../../../../ui/index.ts";
import { showError, showSuccess } from "../../../../../utils/toast.ts";
import { useOffboardingWithdraw } from "../../hooks/use-offboarding-withdraw.ts";
import styles from "./withdraw-modal.module.css";

export interface WithdrawModalProps {
    open: boolean;
    onClose: () => void;
    offboardingId: number;
    onSuccess: () => void;
}

export function WithdrawModal({
    open,
    onClose,
    offboardingId,
    onSuccess,
}: WithdrawModalProps) {
    const [reason, setReason] = useState("");
    const [reasonError, setReasonError] = useState<string | undefined>();
    const { withdraw, loading, error } = useOffboardingWithdraw();

    useEffect(() => {
        if (!open) {
            setReason("");
            setReasonError(undefined);
        }
    }, [open]);

    useEffect(() => {
        if (error) showError(error);
    }, [error]);

    const handleSubmit = async () => {
        const trimmed = reason.trim();
      

        setReasonError(undefined);

        const ok = await withdraw({ offboardingId, reason: trimmed });
        if (ok) {
            showSuccess("Offboarding request withdrawn successfully.");
            onSuccess();
            onClose();
        }
    };

    return (
      <Modal
        open={open}
        onClose={onClose}
        title="Withdraw Offboarding Request"
        size="md"
        footer={
          <div className={styles.footer}>
            <Button variant="light-grey" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleSubmit} disabled={loading}>
              {loading ? "Submitting..." : "Submit Withdrawal"}
            </Button>
          </div>
        }
      >
        <div className={styles.body}>
       
          <TextArea
            label="Reason for withdrawal"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (reasonError) setReasonError(undefined);
            }}
            error={reasonError}
            placeholder="Type your reason here..."
          />
        </div>
      </Modal>
    );
}
